import type { CurrencyCode } from "schemas/project";

// NOTE (Kurt, 2025-04-01): We use the Intl API's standardized currency formatting to
// extract the currency symbol. We strip the digits and whitespace to get just the symbol.
// This handles all currency formats consistently across different locales for proper symbol representation.
// Taken from: https://stackoverflow.com/questions/50650503/get-the-currency-symbol-for-a-locale
export function getCurrencySymbol(currency: CurrencyCode) {
  return (0)
    .toLocaleString("en", {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
}
